var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g, _path75, _path76, _path77, _path78, _path79, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChairAdjustable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 146,
    viewBox: "0 0 92 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9419 56.1888L28.2807 50.792L31.4719 52.6222L29.3601 53.8424L29.1254 53.9831L20.3966 56.2357C20.3497 56.2357 19.7397 56.1888 18.9419 56.1888Z",
    fill: "#605657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5776 97.0171L28.4692 94.1075L28.5632 93.9198L28.657 93.7321L28.7978 93.4975L28.8917 93.3097L29.0325 93.1689L29.1732 92.9812L29.314 92.8404L29.5018 92.6527L29.6425 92.512L29.8302 92.3712L30.0179 92.2303L30.2057 92.1365L30.4403 91.9957L30.628 91.9019L30.8627 91.808L31.0503 91.7141L31.285 91.6672L31.5196 91.6203L31.7543 91.5734L31.9889 91.5264L32.2705 91.4795H32.5052H32.7398H33.0214H33.3029L33.5376 91.5264L33.8192 91.5734L34.0538 91.6203L34.3353 91.6672L34.57 91.7611L34.8046 91.8549L35.0393 91.9488L35.2739 92.0427L35.5086 92.1834L35.6963 92.2773L35.931 92.4181L36.1187 92.5589L36.3533 92.7466L36.5411 92.8874L36.7287 93.0751L36.9164 93.2159L37.0572 93.4036L37.245 93.5913L37.3857 93.779L37.5265 93.9667L37.6673 94.2014L37.7612 94.3891L37.902 94.6238L37.9958 94.8584L38.0896 95.0461L38.1836 95.2807L38.2304 95.5154L38.2774 95.75L38.3243 95.9846L38.3713 96.2193V96.4539L38.4182 96.6886L37.5735 99.4105L27.5776 97.0171Z",
    fill: "#766C60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7432 92.3242L35.931 92.4181L36.1186 92.5589L36.3533 92.7466L36.5411 92.8873L36.7287 93.0751L36.9164 93.2159L37.0572 93.4035L37.245 93.5913L37.3857 93.779L37.5265 93.9667L37.6673 94.2014L37.7611 94.3891L37.902 94.6237L37.9958 94.8584L38.0896 95.0461L38.1836 95.2807L38.2304 95.5153L38.2774 95.75L38.3243 95.9846L38.3712 96.2193V96.4539L38.4182 96.6886L37.5735 99.4105L30.8157 97.7679L29.8302 94.5768L29.314 94.4829L29.4078 93.9667L31.8012 92.8404L35.7432 92.3242Z",
    fill: "#231D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6416 92.5589L29.8762 92.3712L30.064 92.2304L30.2517 92.0896L30.4395 91.9957L30.6272 91.9019L30.8618 91.8081L31.0964 91.7142L31.3311 91.6203L31.5657 91.5734L31.8004 91.5265L32.035 91.4795L32.2697 91.4326H32.5043H32.7389H33.0206H33.3021L33.5837 91.4795L33.8652 91.5265L34.0998 91.5734L34.3345 91.6203L34.5691 91.7142L34.8038 91.8081L35.0384 91.9019L35.2731 91.9957L35.5077 92.0896L35.7423 92.2304L35.977 92.3712L36.1648 92.512L36.3524 92.6528L36.5402 92.7936L36.7279 92.9813L36.9156 93.169L37.1033 93.3567L37.2442 93.5444L37.3848 93.7321L37.5257 93.9199L37.6665 94.1075L37.8073 94.2953L37.9011 94.5299L37.9949 94.7645L38.0888 94.9992L38.1827 95.2338L38.2296 95.4685L38.2766 95.7031L38.3234 95.9378L38.3704 96.1724V96.4071C38.1358 95.9378 37.8072 95.4215 37.5257 95.0461C36.9156 94.3422 35.5077 93.3567 33.6305 93.122C31.7534 92.8874 30.3455 93.9199 30.3455 93.9199L29.6416 92.5589Z",
    fill: "url(#paint0_linear_2_31607)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0496 92.0422C31.0496 92.0422 31.0496 92.9807 31.0496 93.0746C31.0496 93.2154 31.0028 93.4031 30.7681 93.6847C30.4396 94.1071 29.1256 94.764 28.6094 94.4355V91.0566L31.0496 92.0422Z",
    fill: "url(#paint1_linear_2_31607)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.212 99.1754L36.7283 98.6123H36.9159L36.3998 100.208L36.1182 99.9263L36.1651 99.7385V99.5509L36.212 99.3632V99.1754Z",
    fill: "#4E4631"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4575 94.1543C35.2732 94.4359 37.5728 96.7823 37.5728 99.3634L36.5404 99.2695C36.5404 101.334 34.7101 102.836 32.4575 102.648C30.2049 102.414 28.3747 100.584 28.3747 98.4718L27.3423 98.3779C27.3423 95.7968 29.6417 93.8728 32.4575 94.1543Z",
    fill: "#35281F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4575 94.154C35.2733 94.4356 37.5728 96.782 37.5728 99.3631L36.5404 99.2692C36.5404 101.334 34.7101 102.836 32.4575 102.648C32.2229 102.648 32.0352 102.601 31.8006 102.554L31.6129 100.489L29.8296 94.5764C30.5805 94.2479 31.519 94.0602 32.4575 94.154Z",
    fill: "#251E18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7315 101.757L30.862 94.3891L28.6094 91.9487L35.2732 90.6348L45.6915 96.407C45.6915 96.407 45.6446 96.6885 45.5507 97.1109C44.7998 97.2517 44.1428 97.5332 43.5327 97.8618C42.4065 98.5188 41.8433 99.3635 41.8433 100.208V101.569C40.7639 101.663 39.7315 101.757 39.7315 101.757Z",
    fill: "#626049"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0314 99.4106C42.0314 99.4106 32.5049 91.6205 32.5049 91.8082C32.5049 91.9959 37.5262 89.6494 37.5262 89.6494L45.4573 94.3893L43.8148 98.7536L42.0314 99.4106Z",
    fill: "#54555A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4352 110.392C53.4352 111.236 52.872 112.081 51.7457 112.738C50.6194 113.395 49.1177 113.723 47.6629 113.723C46.2081 113.723 44.7064 113.395 43.5801 112.738C42.4538 112.081 41.8906 111.236 41.8906 110.392C41.8906 109.688 41.8906 100.912 41.8906 100.161C41.8906 99.3163 42.4538 98.4716 43.5801 97.8146C44.7064 97.1576 46.2081 96.8291 47.6629 96.8291C49.1177 96.8291 50.6194 97.1576 51.7457 97.8146C52.872 98.4716 53.4352 99.3163 53.4352 100.161C53.4352 100.912 53.4352 109.688 53.4352 110.392Z",
    fill: "url(#paint2_linear_2_31607)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0039 101.241L73.8955 98.3311L73.9893 98.1435L74.0833 97.9088L74.224 97.7211L74.3179 97.5334L74.4586 97.3925L74.5994 97.2049L74.7872 97.0172L74.9279 96.8763L75.1157 96.7356L75.2565 96.5948L75.4442 96.454L75.6318 96.3601L75.8665 96.2193L76.0543 96.1255L76.2889 96.0317L76.4766 95.9378L76.7112 95.8909L76.9459 95.8439L77.1805 95.75H77.4152L77.6968 95.7031H77.9314H78.2129H78.4476H78.7292L78.9638 95.75L79.2455 95.797L79.4801 95.8439L79.7616 95.8909L79.9962 95.9847L80.2309 96.0786L80.4655 96.1724L80.7002 96.2663L80.9348 96.4071L81.1695 96.5009L81.3573 96.6417L81.5919 96.7825L81.7796 96.9702L81.9672 97.111L82.155 97.2518L82.3427 97.4395L82.4835 97.6272L82.6712 97.8149L82.812 98.0026L82.9528 98.1904L83.0936 98.425L83.2344 98.6127L83.3282 98.8474L83.4221 99.0351L83.5159 99.2697L83.6097 99.5043L83.6567 99.739L83.7037 99.9736L83.7506 100.208L83.7975 100.443L83.8444 100.678V100.912L82.9998 103.634L73.0039 101.241Z",
    fill: "url(#paint3_linear_2_31607)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4769 96.2189C76.4769 96.2189 76.4769 97.1575 76.4769 97.2514C76.4769 97.3921 76.43 97.5798 76.1954 97.8614C75.8669 98.2838 74.5528 98.9408 74.0366 98.6123V95.2334L76.4769 96.2189Z",
    fill: "url(#paint4_linear_2_31607)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6392 103.399L82.1555 102.836H82.3432L81.827 104.431L81.5454 104.15L81.5924 103.962L81.6392 103.775V103.587V103.399Z",
    fill: "#4E4631"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8847 98.378C80.7004 98.6595 83 101.006 83 103.587L81.9675 103.493C81.9675 105.558 80.1373 107.06 77.8847 106.872C75.6321 106.637 73.8019 104.807 73.8019 102.695L72.7695 102.602C72.7695 100.02 75.069 98.0964 77.8847 98.378Z",
    fill: "url(#paint5_linear_2_31607)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4346 101.005V105.276L72.0653 98.4712H72.1121L72.2061 98.4243L72.2529 98.3774L72.3937 98.3304L72.4876 98.2366L72.6754 98.1427L72.8161 98.0958L73.0038 97.955L73.1915 97.8611L73.3793 97.7673L73.567 97.6735L73.8016 97.5327L74.0363 97.3918L74.2709 97.298L74.5055 97.1572L74.6932 97.0634L74.9279 96.9226L75.1625 96.7818L75.3971 96.6879L75.5849 96.5472L75.8196 96.4533L76.0072 96.3125L76.195 96.2186L76.3827 96.1248L76.5235 96.031L76.6643 95.9371L76.805 95.8901L76.899 95.8432L76.9928 95.7963L77.0397 95.7493L77.0866 95.7024L77.1805 95.6555L77.2274 95.5617V95.4678V91.1973V91.2911L77.1805 91.385L77.0866 91.4319L77.0397 91.4788L76.9928 91.5257L76.899 91.5727L76.805 91.6196L76.6643 91.6666L76.5235 91.7604L76.3827 91.8543L76.195 91.9481L76.0072 92.042L75.8196 92.1828L75.5849 92.2767L75.3971 92.4174L75.1625 92.5113L74.9279 92.652L74.6932 92.7459L74.5055 92.8867L74.2709 93.0275L74.0363 93.1213L73.8016 93.2621L73.567 93.4029L73.3793 93.4968L73.1915 93.5906L73.0038 93.6845L72.8161 93.7783L72.6754 93.8722L72.4876 93.9661L72.3937 94.013L72.2529 94.1068L72.2061 94.1538H72.1121L72.0653 94.2007L53.4346 101.005Z",
    fill: "url(#paint6_linear_2_31607)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4347 101.006L72.1123 94.201C72.1123 94.201 76.8991 91.6199 77.1337 91.4322C77.3684 91.2445 77.3214 91.0099 77.0398 90.7752C76.7582 90.5406 76.5705 90.3529 76.1482 90.1652C75.7258 90.0244 75.2096 89.9775 74.8342 90.2121C74.4587 90.3998 70.4229 92.7932 70.4229 92.7932L49.0703 99.0816L52.4961 101.053L53.4347 101.006Z",
    fill: "#53565D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0903 127.426L80.982 124.564L81.0759 124.329L81.1697 124.141L81.2636 123.954L81.4044 123.766L81.5452 123.578L81.686 123.437L81.8268 123.25L81.9675 123.109L82.1553 122.968L82.3429 122.827L82.5307 122.686L82.7184 122.546L82.9061 122.452L83.1407 122.358L83.3285 122.264L83.5631 122.17L83.7978 122.123L84.0324 122.029L84.2671 121.983L84.5017 121.936H84.7363L85.0179 121.889H85.2525H85.5341L85.7688 121.936L86.0504 121.983H86.285L86.5665 122.076L86.8012 122.123L87.0358 122.217L87.3174 122.311L87.5521 122.405L87.7867 122.499L87.9744 122.593L88.209 122.733L88.4437 122.874L88.6315 123.015L88.8191 123.156L89.0068 123.343L89.1946 123.484L89.3823 123.672L89.57 123.86L89.7107 124.047L89.8985 124.235L90.0393 124.423L90.1332 124.611L90.274 124.845L90.3678 125.033L90.5086 125.268L90.6024 125.502L90.6493 125.737L90.7433 125.971L90.7901 126.206L90.8371 126.441L90.8839 126.675V126.91V127.145L90.0862 129.82L80.0903 127.426Z",
    fill: "url(#paint7_linear_2_31607)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5623 122.452C83.5623 122.452 83.5623 123.391 83.5623 123.485C83.5623 123.626 83.5154 123.813 83.2807 124.095C82.9522 124.517 81.6383 125.174 81.1221 124.846V121.467L83.5623 122.452Z",
    fill: "url(#paint8_linear_2_31607)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9713 124.611C87.787 124.893 90.0865 127.239 90.0865 129.82L89.054 129.726C89.054 131.791 87.2238 133.293 84.9713 133.105C82.7187 132.87 80.8885 131.04 80.8885 128.928L79.856 128.835C79.856 126.207 82.1555 124.329 84.9713 124.611Z",
    fill: "url(#paint9_linear_2_31607)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.042 104.901V109.078L76.8058 120.951L76.8528 120.998H76.9466L77.0405 121.045H77.1344L77.2751 121.092L77.4159 121.139L77.6037 121.186L77.7914 121.233L78.026 121.326L78.2137 121.373L78.4483 121.467L78.683 121.514L78.9176 121.608L79.1993 121.655L79.4339 121.749L79.7155 121.796L79.9502 121.89L80.1848 121.983L80.4663 122.03L80.701 122.124L80.9356 122.171L81.1702 122.265L81.358 122.312L81.5927 122.359L81.7803 122.406L81.9211 122.453L82.1088 122.5L82.2496 122.547L82.3435 122.594H82.4373L82.4843 122.64H82.5781L82.6719 122.687H82.7659L82.8597 122.734H82.9536H83.0474H83.1412H83.1882H83.282H83.3759L83.4228 122.687H83.5167L83.6105 122.64L83.6575 122.594L83.7513 122.547L83.8452 122.453L83.986 122.359L84.0798 122.218L84.1737 122.124L84.2676 122.077L84.3144 121.983L84.3614 121.937L84.4084 121.89L84.4553 121.796V121.749L84.5022 121.702V121.655V121.608L84.5491 121.561V117.384L84.5022 117.478V117.525L84.4553 117.572V117.619V117.666L84.4084 117.713L84.3614 117.76L84.3144 117.807L84.2676 117.901L84.1737 117.995L84.0798 118.088L83.986 118.182L83.8452 118.323L83.7513 118.37L83.6575 118.417L83.6105 118.464L83.5167 118.511H83.4228L83.3759 118.558H83.282H83.1882H83.1412H83.0474H82.9536H82.8597L82.7659 118.511H82.6719L82.5781 118.464H82.4843H82.4373L82.3435 118.417L82.2496 118.37L82.1088 118.323H81.9211L81.7803 118.229L81.5927 118.182L81.358 118.135L81.1702 118.088L80.9356 117.995L80.701 117.948L80.4663 117.854L80.1848 117.807L79.9502 117.713L79.7155 117.666L79.4339 117.572L79.1993 117.478L78.9176 117.431L78.683 117.337L78.4483 117.291L78.2137 117.197L78.026 117.15L77.7914 117.103L77.6037 117.009L77.4159 116.962L77.2751 116.915L77.1344 116.868H77.0405L76.9466 116.821H76.8528L76.8058 116.774L51.042 104.901Z",
    fill: "url(#paint10_linear_2_31607)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8809 120.105L76.8049 120.95L76.8518 120.997H76.9457L77.0395 121.044H77.1335L77.2742 121.091L77.415 121.138L77.6028 121.185L77.7904 121.232L78.0251 121.326L78.2127 121.372L78.4474 121.466L78.682 121.513L78.9167 121.607L79.1983 121.654L79.4329 121.748L79.7145 121.795L79.9492 121.889L80.1838 121.983L80.4653 122.029L80.7 122.123L80.9346 122.17L81.1693 122.264L81.3571 122.311L81.5917 122.358L81.7794 122.405L81.9202 122.452L82.1078 122.499L82.2487 122.546L82.3425 122.593H82.4363L82.4833 122.64H82.5771L82.671 122.686H82.7649L82.8588 122.733H82.9526H83.0464H83.1403H83.1872H83.2811H83.3749L83.4219 122.686H83.5157L83.6095 122.64L83.6565 122.593L83.7504 122.546L83.8442 122.452L83.985 122.358L84.0788 122.217L84.1728 122.123L84.2666 122.076L84.3135 121.983L84.3604 121.936L84.4074 121.889L84.4543 121.795V121.748L84.5013 121.701V121.654V121.607L84.5481 121.56V117.384L84.5013 117.477V117.524L84.4543 117.571V117.618V117.665L84.4074 117.712L84.3604 117.759L84.3135 117.806L84.2666 117.9L84.1728 117.994L84.0788 118.087L83.985 118.181L83.8442 118.322L83.7504 118.369L83.6565 118.416L83.6095 118.463L83.5157 118.51H83.4219L83.3749 118.557H83.2811H83.1872H83.1403H83.0464H82.9526H82.8588L82.7649 118.51H82.671L82.5771 118.463H82.4833H82.4363L82.3425 118.416L82.2487 118.369L82.1078 118.322H81.9202L81.7794 118.228L81.5917 118.181L81.3571 118.134L81.1693 118.087L80.9346 117.994L80.7 117.947L80.4653 117.853L80.1838 117.806L79.9492 117.712L79.7145 117.665L79.4329 117.571L79.1983 117.477L78.9167 117.43L78.682 117.337L78.4474 117.29L78.2127 117.196L78.0251 117.149L77.7904 117.102L77.6028 117.008L77.415 116.961L77.2742 116.914L77.1335 116.867H77.0395L76.9457 116.82H76.8518L76.8049 116.773L74.8809 115.929V120.105Z",
    fill: "url(#paint11_linear_2_31607)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.042 104.901L76.8058 116.774C76.8058 116.774 81.9681 118.322 82.4843 118.463C83.0005 118.604 83.3759 118.651 83.7983 118.322C84.2207 117.947 84.3145 117.806 84.4084 117.665C84.5023 117.524 84.7369 117.149 83.7983 116.867C82.8597 116.586 78.1668 115.131 78.1668 115.131L53.3884 102.226C53.3884 103.07 52.8252 103.915 51.6989 104.572C51.5112 104.713 51.2766 104.807 51.042 104.901Z",
    fill: "url(#paint12_linear_2_31607)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8052 116.773C76.8052 116.773 81.9674 118.322 82.4836 118.463C82.9998 118.604 83.3753 118.651 83.7976 118.322C84.22 117.947 84.3139 117.806 84.4077 117.665C84.5016 117.524 84.7362 117.149 83.7976 116.867C82.8591 116.586 78.1662 115.131 78.1662 115.131L76.8052 116.773Z",
    fill: "#4A4D56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2153 139.488L40.1069 136.625L40.2008 136.391L40.2947 136.203L40.3886 136.015L40.5294 135.827L40.6701 135.64L40.8109 135.499L40.9517 135.311L41.0925 135.17L41.2802 135.03L41.4679 134.889L41.6556 134.748L41.8433 134.607L42.0311 134.513L42.2657 134.419L42.4534 134.326L42.688 134.232L42.9227 134.185L43.1573 134.091L43.3919 134.044L43.6266 133.997H43.8612L44.0959 133.95H44.3775H44.6121L44.8936 133.997H45.1753L45.4099 134.044L45.6915 134.138L45.9262 134.185L46.1608 134.279L46.3955 134.326L46.6301 134.466L46.8647 134.56L47.0994 134.654L47.334 134.795L47.5687 134.936L47.7563 135.076L47.944 135.217L48.1318 135.405L48.3195 135.546L48.5073 135.734L48.6949 135.921L48.8357 136.109L48.9765 136.297L49.1172 136.484L49.258 136.672L49.3989 136.907L49.4927 137.094L49.5865 137.329L49.6805 137.564L49.7743 137.798L49.8681 138.033L49.9151 138.268L49.962 138.502V138.737L50.0089 138.972V139.206L49.2112 141.881L39.2153 139.488Z",
    fill: "url(#paint13_linear_2_31607)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92822 120.622L7.81982 117.759L7.91377 117.524L8.00761 117.337L8.10144 117.149L8.24225 116.961L8.38306 116.773L8.52376 116.586L8.66456 116.445L8.85235 116.304L8.99304 116.163L9.18083 116.023L9.3685 115.882L9.55628 115.741L9.74395 115.647L9.97859 115.553L10.1663 115.459L10.4009 115.366L10.6355 115.272L10.8702 115.225L11.1048 115.178L11.3395 115.131H11.5741L11.8557 115.084H12.0904H12.372L12.6066 115.131H12.8882L13.1228 115.178L13.4044 115.225L13.6391 115.319L13.8737 115.412L14.1552 115.459L14.3899 115.553L14.6245 115.694L14.8123 115.788L15.0469 115.929L15.2816 116.069L15.4692 116.21L15.657 116.351L15.8917 116.492L16.0324 116.68L16.2201 116.867L16.4078 117.055L16.5486 117.243L16.7363 117.43L16.8771 117.618L16.9709 117.806L17.1117 118.04L17.2056 118.228L17.3464 118.463L17.4402 118.697L17.4872 118.932L17.581 119.12L17.628 119.354L17.6749 119.636L17.7218 119.871V120.105V120.34L16.9241 123.015L6.92822 120.622Z",
    fill: "url(#paint14_linear_2_31607)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94629 116.163L9.18093 115.976L9.3686 115.835L9.55639 115.694L9.74406 115.6L9.93172 115.506L10.1664 115.413L10.401 115.319L10.6357 115.225L10.8703 115.178L11.1049 115.131L11.3396 115.084L11.5742 115.037H11.8089H12.0435H12.3251H12.6068L12.8883 115.084L13.1699 115.131L13.4045 115.178L13.6392 115.225L13.8738 115.319L14.1085 115.413L14.3431 115.506L14.5777 115.6L14.8124 115.694L15.047 115.835L15.2817 115.976L15.4693 116.116L15.6571 116.257L15.8448 116.398L16.0325 116.586L16.2202 116.773L16.4079 116.961L16.5487 117.149L16.6895 117.337L16.8303 117.524L16.971 117.712L17.1118 117.9L17.2057 118.134L17.2996 118.369L17.3935 118.604L17.4873 118.838L17.5343 119.073L17.5811 119.308L17.6281 119.542L17.675 119.777V120.012C17.4403 119.542 17.1119 119.026 16.8303 118.651C16.2203 117.947 14.8124 116.961 12.9352 116.727C11.0581 116.492 9.65022 117.524 9.65022 117.524L8.94629 116.163Z",
    fill: "url(#paint15_linear_2_31607)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9517 135.311L41.0925 135.17L41.2801 135.03L41.4679 134.889L41.6556 134.748L41.8433 134.607L42.031 134.513L42.2187 134.419L42.4534 134.326L42.688 134.232L42.9226 134.138L43.1573 134.091L43.3919 134.044L43.6266 133.997L43.8612 133.95H44.0959H44.3305H44.4713C44.3305 134.654 44.049 135.546 43.8144 135.687C43.5797 135.874 41.7026 136.625 41.7026 136.625L40.9517 135.311Z",
    fill: "#1C1815"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6878 134.513C42.6878 134.513 42.6878 135.451 42.6878 135.545C42.6878 135.686 42.641 135.874 42.4063 136.155C42.0778 136.578 40.7638 137.235 40.2476 136.906V133.527L42.6878 134.513Z",
    fill: "url(#paint16_linear_2_31607)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4012 115.648C10.4012 115.648 10.4012 116.586 10.4012 116.68C10.4012 116.821 10.3544 117.009 10.1197 117.29C9.79121 117.712 8.47715 118.369 7.96094 118.041V114.662L10.4012 115.648Z",
    fill: "url(#paint17_linear_2_31607)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8033 141.646L48.3664 141.13H48.5073L48.038 142.725L47.7563 142.397V142.209L47.8033 142.022V141.834V141.646Z",
    fill: "#4E4631"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5636 122.781L16.0798 122.265H16.2206L15.7513 123.86L15.4697 123.532L15.5167 123.344V123.156V122.969L15.5636 122.781Z",
    fill: "#4E4631"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0961 136.672C46.9119 136.953 49.2115 139.3 49.2115 141.881L48.1789 141.787C48.1789 143.852 46.3487 145.353 44.0961 145.166C41.8436 144.931 40.0134 143.101 40.0134 140.989L38.981 140.895C38.981 138.267 41.2335 136.39 44.0961 136.672Z",
    fill: "#4D4230"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8095 117.806C14.6253 118.088 16.9248 120.434 16.9248 123.015L15.8924 122.922C15.8924 124.986 14.0621 126.488 11.8095 126.3C9.55694 126.066 7.72675 124.236 7.72675 122.124L6.69434 122.03C6.69434 119.402 8.9938 117.525 11.8095 117.806Z",
    fill: "#4D4230"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6983 97.8146C52.8246 98.4716 53.3878 99.3163 53.3878 100.161C53.3878 101.006 52.8246 101.85 51.6983 102.507C50.572 103.164 49.0703 103.493 47.6155 103.493C46.1607 103.493 44.659 103.164 43.5327 102.507C42.4065 101.85 41.8433 101.006 41.8433 100.161C41.8433 99.3163 42.4065 98.4716 43.5327 97.8146C44.659 97.1576 46.1607 96.8291 47.6155 96.8291C49.0703 96.8291 50.572 97.1576 51.6983 97.8146Z",
    fill: "url(#paint18_linear_2_31607)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5107 100.208C51.5107 100.771 51.1353 101.334 50.3845 101.803C49.6336 102.226 48.6481 102.46 47.6626 102.46C46.6771 102.46 45.6916 102.226 44.9407 101.803C44.1898 101.381 43.8145 100.771 43.8145 100.208C43.8145 98.4244 43.8145 98.5183 43.8145 96.735C43.8145 96.1719 44.1898 95.6087 44.9407 95.1394C45.6916 94.7171 46.6771 94.4824 47.6626 94.4824C48.6481 94.4824 49.6336 94.7171 50.3845 95.1394C51.1353 95.5618 51.5107 96.1719 51.5107 96.735C51.5107 98.5183 51.5107 98.3775 51.5107 100.208Z",
    fill: "url(#paint19_linear_2_31607)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3988 105.417V109.687L43.8143 130.665V130.712V130.759V130.805V130.899L43.7674 130.993L43.7204 131.087L43.6735 131.228L43.6265 131.369L43.5797 131.509L43.5327 131.65L43.4857 131.791L43.4389 131.932L43.3919 132.073L43.345 132.26L43.2981 132.448L43.2511 132.636L43.2042 132.823L43.1573 133.011L43.1104 133.199L43.0634 133.34L43.0164 133.48L42.9696 133.621L42.9226 133.762L42.8757 133.903L42.8288 134.044L42.7818 134.137L42.7349 134.231L42.688 134.325L42.6411 134.372V134.419V134.466L42.5941 134.513L42.5472 134.56L42.5003 134.607L42.4533 134.654L42.4065 134.701L42.3595 134.747L42.3125 134.794L42.2187 134.841L42.1248 134.888L42.031 134.935H41.9372H41.8432H41.7494H41.6086H41.4679H41.3271H41.1863H41.0455H40.9046H40.764H40.6231H40.4823L40.3415 134.888L40.2007 134.841L40.1069 134.794L40.013 134.747L39.9192 134.701L39.8254 134.654L39.7784 134.607L39.7314 134.56L39.6846 134.466V134.372V130.102C39.7315 130.43 41.7025 130.571 42.4533 127.943L42.5003 127.802L42.5472 127.661L42.5941 127.474L42.6411 127.286L42.688 127.098L43.2981 128.224L43.345 128.037L43.3919 127.849L43.4389 127.708L43.4857 127.567L43.5327 127.427L43.5797 127.286L43.6265 127.145L43.6735 127.004L43.7204 126.863L43.7674 126.77L43.8143 126.676V126.582V126.535V126.488V126.441L49.3988 105.417Z",
    fill: "url(#paint20_linear_2_31607)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3991 105.417V109.687L46.8649 119.355L45.8794 118.651L49.3991 105.417Z",
    fill: "url(#paint21_linear_2_31607)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3993 105.418L43.8148 126.395C43.8148 126.395 42.9232 129.867 42.7354 130.149C42.5477 130.431 42.2192 130.618 41.4214 130.618C40.6236 130.618 39.7319 130.477 39.7319 130.055C39.7319 129.633 40.7645 126.348 40.7645 126.348L44.1433 104.948L49.3993 105.418Z",
    fill: "url(#paint22_linear_2_31607)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6265 127.239C43.3449 128.272 42.8756 129.961 42.7817 130.149C42.594 130.43 42.2656 130.618 41.4678 130.618C40.67 130.618 39.7783 130.477 39.7783 130.055C39.7783 129.633 40.8107 126.348 40.8107 126.348L40.9515 125.597L42.0778 126.394L43.6265 127.239Z",
    fill: "#635957"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8611 126.395C43.8611 126.395 42.9694 129.867 42.7817 130.149C42.594 130.43 42.2656 130.618 41.4678 130.618C40.67 130.618 39.7783 130.477 39.7783 130.055C39.7783 129.633 40.8107 126.348 40.8107 126.348L43.8611 126.395Z",
    fill: "#302A2E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6265 127.239C43.3449 128.272 42.8756 129.961 42.7817 130.149C42.594 130.43 42.2656 130.618 41.4678 130.618C40.67 130.618 39.7783 130.477 39.7783 130.055C39.7783 129.633 40.8107 126.348 40.8107 126.348L42.0309 126.395L43.6265 127.239Z",
    fill: "#544741"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9225 104.15V108.327L14.5775 115.273H14.5306H14.4367L14.3429 115.319H14.1551H14.0144H13.8266L13.592 115.366H13.3573L13.1227 115.413H12.8881L12.6066 115.46H12.3249L11.9965 115.507H11.7148L11.4333 115.554H11.1047L10.8232 115.601H10.4948L10.2131 115.648H9.93152L9.65001 115.695H9.41537L9.18073 115.742H8.94608L8.71144 115.789H8.52366H8.38296H8.24215L8.10134 115.836H8.00751H7.96053H7.91367H7.81972L7.77286 115.789H7.67903L7.63205 115.742L7.53822 115.695L7.49125 115.648H7.44439L7.35044 115.601L7.30358 115.554L7.2566 115.507L7.20974 115.46L7.16277 115.413L7.11579 115.366L7.06893 115.319V115.273L7.02196 115.179V115.085V114.991L6.9751 114.897V110.72L8.33599 110.016V110.11L8.38296 110.204V110.298L8.42982 110.345V110.392L8.4768 110.439L8.52366 110.486L8.57063 110.533L8.6176 110.58L8.66446 110.627H8.7583L8.80527 110.674L8.89911 110.72L8.94608 110.767L9.03992 110.814H9.08689H9.18073L9.22759 110.861H9.32154H9.3684L9.41537 110.814H9.55618H9.69688H9.83768L10.0255 110.767H10.2601H10.4948L10.7294 110.72H11.0109L11.2455 110.674H11.574L11.8556 110.627H12.1373L11.1047 111.377H11.4333L11.7148 111.331H11.9965L12.3249 111.284H12.6066L12.8881 111.237H13.1227L13.3573 111.19H13.592H13.8266L14.0144 111.143H14.1551H14.3429L14.4367 111.096H14.5306H14.5775L42.9225 104.15Z",
    fill: "url(#paint23_linear_2_31607)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9227 104.15V108.327L22.9312 113.208V109.078L42.9227 104.15Z",
    fill: "url(#paint24_linear_2_31607)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9225 104.15L14.5775 111.095C14.5775 111.095 8.33596 111.659 7.96053 111.659C7.5851 111.659 7.16279 111.283 7.06893 111.095C6.97507 110.908 6.9751 110.485 6.9751 110.485C6.9751 110.485 7.02203 110.11 7.67903 110.016C8.2891 109.922 14.2021 109.312 14.2021 109.312L41.8431 101.1V102.226C41.8431 102.93 42.2185 103.587 42.9225 104.15Z",
    fill: "url(#paint25_linear_2_31607)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.563 110.861L14.5775 111.096C14.5775 111.096 8.33596 111.659 7.96053 111.659C7.5851 111.659 7.16279 111.283 7.06893 111.096C6.97507 110.908 6.9751 110.486 6.9751 110.486C6.9751 110.486 7.02203 110.11 7.67903 110.016C8.10139 109.969 11.1986 109.594 12.9819 109.406L14.4837 110.392L15.563 110.861Z",
    fill: "#6A6667"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5273 117.619L81.7799 116.258L83.8448 116.868L82.5777 117.619L80.3721 117.853L79.5273 117.619Z",
    fill: "#676163"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32162 44.9254L9.36848 44.9723L9.41546 45.0192L9.46232 45.0661L9.50929 45.1131L9.55627 45.16L9.60313 45.2069L9.69696 45.2539L9.79091 45.3008L9.88474 45.3478L9.97858 45.3947L10.0724 45.4416L10.1662 45.4885L10.2602 45.5354L10.354 45.5824L10.4479 45.6293L10.5417 45.7231L10.6355 45.817L10.7295 45.9109L10.8233 46.0047L10.9172 46.0517L11.011 46.0986L11.1048 46.1455L11.1988 46.1924L11.2926 46.2394L11.3864 46.2863L11.4803 46.3332L11.5741 46.3802L11.6681 46.4271L11.7619 46.474L11.8557 46.521L11.9027 46.5679L11.9965 46.6148L12.0904 46.6617L12.1842 46.7086L12.278 46.7556H12.372H12.4658H12.5597H12.6535H12.7473H12.8413H12.9351H13.029H13.1228H13.2166H13.3106H13.4044H13.4982H13.5921L13.6859 46.7086L13.7799 46.6617L13.8737 46.6148L13.9675 46.5679L14.0614 46.521L14.1552 46.474L14.2491 46.4271L14.343 46.3802L14.4368 46.3332L14.5306 46.2863L14.6245 46.2394L14.7184 46.1924L14.8123 46.0986L14.9531 46.0047L15.1877 45.817L15.5162 45.5824L15.9385 45.2539L16.4548 44.8785L17.0649 44.4561L17.7218 43.9868L18.4258 43.4706L19.1767 42.9074L19.9744 42.3443L20.8192 41.7342C22.3678 40.6548 23.9164 39.5755 25.4181 38.4961L26.3567 37.8391C27.5768 36.9944 28.7501 36.1497 29.9703 35.2581L30.8149 34.648L31.6128 34.0848L32.3636 33.5686L33.0675 33.0993L33.6776 32.677L34.2407 32.3015L34.71 31.9731L35.0855 31.6914L35.3671 31.5038L35.5548 31.363L35.6486 31.316L35.7424 31.2691L35.8364 31.1752L35.9302 31.0814L36.0241 30.9875L36.071 30.8937L36.1179 30.7998L36.1649 30.659L36.2117 30.5182V30.3775V30.2367L36.0241 28.2188L8.66455 42.3443L8.85233 44.3622V44.4561L8.89919 44.5499L8.94617 44.6438L8.99303 44.7377L9.04 44.8315L9.32162 44.9254Z",
    fill: "url(#paint26_linear_2_31607)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13434 42.9554C9.13434 42.9554 11.0585 44.2225 11.7624 44.6449C12.4663 45.0203 13.6865 45.0203 14.7189 44.2225C15.7514 43.4247 35.2267 29.7215 35.6491 29.393C36.0245 29.0645 36.5877 28.1729 35.7899 27.5628C34.9921 26.9527 33.6781 26.2488 33.3496 26.0141C33.0211 25.7795 31.6133 25.5448 30.9094 26.0141C30.2054 26.4834 9.69753 40.7967 9.18132 41.3129C8.75896 41.8291 8.75891 42.533 9.13434 42.9554Z",
    fill: "#746E70"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5285 91.3381L66.0122 90.6342L69.3912 88.5693L70.2828 90.3526L68.6403 91.5728L66.5285 91.3381Z",
    fill: "#191814"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5044 91.9953L32.5513 90.212L31.2842 87.8186L26.5444 86.7393L29.9703 92.183L32.5044 91.9953Z",
    fill: "#080904"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74414 69.9385V75.3353V75.4761L9.79112 75.6169V75.7577L9.83798 75.8985L9.88495 76.0392L9.97878 76.1801L10.0258 76.3209L10.0726 76.4616L10.1665 76.6024L10.2604 76.7432L10.3542 76.884L10.495 77.0248L10.5889 77.1655L10.7297 77.3064L10.8704 77.4471L11.0582 77.5879L11.199 77.7287L11.3866 77.8695L11.5743 78.0103L11.809 78.198L12.0436 78.3388L12.2782 78.4796L12.5599 78.6673L12.8415 78.8081L13.17 79.0427L13.6861 79.3243L14.2962 79.6528L15.0001 80.0752L15.8449 80.5445L16.7835 81.1076L17.769 81.6707L18.8953 82.3277L20.0215 82.9847L21.2417 83.6887L22.5557 84.4395L23.8228 85.1904L25.1837 85.9413L26.5447 86.739L27.9056 87.5368L29.3134 88.3346L30.6744 89.1324L32.0353 89.9302L33.3493 90.6811L34.6634 91.4319L35.9304 92.1358L37.1036 92.8398L38.2769 93.4968L39.3562 94.1068L40.3417 94.7169L41.2334 95.2331L42.0312 95.7024L42.7351 96.0779L43.2982 96.4063L43.7675 96.6879L44.096 96.8756L44.2368 96.9695L44.3776 97.0164L44.5184 97.1103L44.6591 97.1572L44.8469 97.2511L45.0815 97.298L45.363 97.3918L45.5977 97.4857L45.9263 97.5326L46.2547 97.6265L46.5832 97.6735L46.9587 97.7673L47.3341 97.8142L47.7095 97.8611L48.1319 97.9081L48.5542 97.955L49.0235 98.0019H49.4928H49.9621H50.4314L50.9476 97.955L51.4638 97.9081L51.98 97.8142L52.4963 97.7673L53.0124 97.6265L53.5756 97.4857L54.0918 97.3449L54.655 97.1572L55.2181 96.9695L55.7343 96.7349L56.2975 96.4533L56.8606 96.1717L57.3768 95.8432L57.9869 95.4678L58.6909 95.0454L59.5356 94.5761L60.4272 94.013L61.4128 93.4029L62.4452 92.7459L63.5714 92.0889L64.7446 91.385L66.0117 90.6341L67.2789 89.8363L68.5928 89.0386L69.9538 88.2407L71.2678 87.396L72.6757 86.5982L74.0366 85.7535L75.3974 84.9088L76.7585 84.111L78.0725 83.2663L79.3864 82.5154L80.6536 81.7177L81.8736 80.9668L83.0469 80.2628L84.1262 79.6059L85.1587 78.9958L86.1442 78.3857L86.9889 77.8695L87.7867 77.4002L88.4437 76.9778L89.0068 76.6024L89.4761 76.3209L89.8047 76.1331L89.9923 75.9923L90.0862 75.8985L90.227 75.8046L90.3678 75.6638L90.5086 75.57L90.6493 75.4292L90.7901 75.2415L90.9309 75.1007L91.0717 74.913L91.1656 74.7253L91.3064 74.5375L91.4472 74.3498L91.541 74.1152L91.6349 73.8805L91.7287 73.6928L91.8225 73.4582L91.8695 73.2235L91.9633 72.9889V72.7542V67.3574V67.5921L91.8695 67.8267L91.8225 68.0614L91.7287 68.296L91.6349 68.5306L91.541 68.7653L91.4472 68.953L91.3064 69.1407L91.1656 69.3754L91.0717 69.5162L90.9309 69.7039L90.7901 69.8916L90.6493 70.0324L90.5086 70.1731L90.3678 70.314L90.227 70.4078L90.0862 70.5486L89.9923 70.6424L89.8047 70.7363L89.4761 70.971L89.0068 71.2525L88.4437 71.581L87.7867 72.0034L86.9889 72.4727L86.1442 73.0358L85.1587 73.599L84.1262 74.256L83.0469 74.913L81.8736 75.6169L80.6536 76.3678L79.3864 77.1186L78.0725 77.9164L76.7585 78.7142L75.3974 79.5589L74.0366 80.3567L72.6757 81.2014L71.2678 82.0462L69.9538 82.8439L68.5928 83.6887L67.2789 84.4864L66.0117 85.2373L64.7446 85.9882L63.5714 86.6921L62.4452 87.396L61.4128 88.0531L60.4272 88.6162L59.5356 89.1793L58.6909 89.6956L57.9869 90.1179L57.3768 90.4933L56.8606 90.8218L56.2975 91.1034L55.7343 91.385L55.2181 91.6196L54.655 91.8074L54.0918 91.995L53.5756 92.1358L53.0124 92.2766L52.4963 92.3705L51.98 92.4643L51.4638 92.5113L50.9476 92.5582L50.4314 92.6051H49.9621H49.4928H49.0235H48.5542L48.1319 92.5582L47.7095 92.5113L47.3341 92.4643L46.9587 92.3705L46.5832 92.3236L46.2547 92.2297L45.9263 92.1828L45.5977 92.0889L45.363 91.995L45.0815 91.9481L44.8469 91.8543L44.6591 91.8074L44.5184 91.7135L44.3776 91.6665L44.2368 91.5727L44.096 91.4788L43.7675 91.2911L43.2982 91.0565L42.7351 90.728L42.0312 90.3056L41.2334 89.8363L40.3417 89.3201L39.3562 88.757L38.2769 88.1469L37.1036 87.4899L35.9304 86.7859L34.6634 86.0351L33.3493 85.2842L32.0353 84.5334L30.6744 83.7356L29.3134 82.9378L27.9056 82.187L26.5447 81.3891L25.1837 80.5914L23.8228 79.7935L22.5557 79.0427L21.2417 78.3388L20.0215 77.6348L18.8953 76.9309L17.769 76.3209L16.7835 75.7108L15.8449 75.1946L15.0001 74.7253L14.2962 74.3029L13.6861 73.9275L13.17 73.6459L12.8415 73.4582L12.5599 73.2705L12.2782 73.1297L12.0436 72.942L11.809 72.8012L11.5743 72.6604L11.3866 72.5196L11.199 72.3319L11.0582 72.1911L10.8704 72.0503L10.7297 71.9095L10.5889 71.7687L10.495 71.628L10.3542 71.4872L10.2604 71.3464L10.1665 71.2056L10.0726 71.0648L10.0258 70.9241L9.97878 70.7832L9.88495 70.6424L9.83798 70.5017L9.79112 70.3609V70.2201L9.74414 70.0793V69.9385Z",
    fill: "url(#paint27_linear_2_31607)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4102 97.392L45.5978 97.4859L45.9264 97.5328L46.2549 97.6267L46.5834 97.6737L46.9588 97.7675L47.3343 97.8144L47.7096 97.8613L48.132 97.9083L48.5544 97.9552L49.0236 98.0021H49.4929H49.9622H50.4315L50.9478 97.9552L51.4639 97.9083L51.9802 97.8144L52.4964 97.7675L53.0126 97.6267L53.5757 97.4859L54.092 97.3451L54.6551 97.1574L55.2182 96.9697L55.7345 96.7351L56.2976 96.4535L56.8607 96.1719L57.377 95.8434L57.9871 95.468L58.691 95.0456L59.5358 94.5763L60.4274 94.0132L61.4129 93.4031L62.4453 92.7461L63.5716 92.0891L64.7448 91.3852L66.0118 90.6343L67.279 89.8365L68.5929 89.0387L69.9539 88.2409L71.268 87.3962L72.6758 86.5984L73.3798 86.1291V80.7793L72.6758 81.2016L71.268 82.0464L69.9539 82.8441L68.5929 83.6889L67.279 84.4866L66.0118 85.2375L64.7448 85.9884L63.5716 86.6923L62.4453 87.3962L61.4129 88.0533L60.4274 88.6164L59.5358 89.1795L58.691 89.6958L57.9871 90.1181L57.377 90.4935L56.8607 90.822L56.2976 91.1036L55.7345 91.3852L55.2182 91.6198L54.6551 91.8076L54.092 91.9952L53.5757 92.136L53.0126 92.2768L52.4964 92.3707L51.9802 92.4645L51.4639 92.5115L50.9478 92.5584L50.4315 92.6053H49.9622H49.4929H49.0236H48.5544L48.132 92.5584L47.7096 92.5115L47.3343 92.4645L46.9588 92.3707L46.5834 92.3238L46.2549 92.2299L45.9264 92.183L45.5978 92.0891L45.4102 92.0422V97.392Z",
    fill: "url(#paint28_linear_2_31607)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7441 84.5335L23.8235 85.1904L25.1844 85.9413L26.5454 86.7391L27.9063 87.5369L29.3142 88.3347L30.6752 89.1325L32.0361 89.9303L33.3501 90.6811L34.6641 91.432L35.9312 92.1359L37.1044 92.8399L38.2776 93.4969L39.357 94.1069L40.3424 94.717L41.2341 95.2332L42.0319 95.7025L42.7358 96.078L43.299 96.4064L43.7683 96.688L44.0967 96.8757L44.2375 96.9696L44.3784 97.0165L44.5192 97.1104L44.6599 97.1573L44.8476 97.2512L45.0823 97.2981L45.3638 97.3919L45.5984 97.4858L45.927 97.5327L46.2555 97.6266L46.584 97.6735L46.9594 97.7674H47.0063V92.4175L46.9594 92.3706L46.584 92.3237L46.2555 92.2298L45.927 92.1828L45.5984 92.089L45.3638 91.9951L45.0823 91.9482L44.8476 91.8544L44.6599 91.8074L44.5192 91.7136L44.3784 91.6666L44.2375 91.5728L44.0967 91.4789L43.7683 91.2912L43.299 91.0565L42.7358 90.7281L42.0319 90.3057L41.2341 89.8364L40.3424 89.3202L39.357 88.7571L38.2776 88.147L37.1044 87.49L35.9312 86.786L34.6641 86.0352L33.3501 85.2843L32.0361 84.5335L30.6752 83.7357L29.3142 82.9379L27.9063 82.187L26.5454 81.3892L25.1844 80.5915L23.8235 79.7936L22.7441 79.1836V84.5335Z",
    fill: "url(#paint29_linear_2_31607)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74414 69.9385V75.3353V75.4761L9.79112 75.6169V75.7577L9.83798 75.8985L9.88495 76.0392L9.97878 76.18L10.0258 76.3208L10.0726 76.4616L10.1665 76.6024L10.2604 76.7431L10.3542 76.884L10.495 77.0248L10.5889 77.1655L10.7297 77.3063L10.8704 77.4471L11.0582 77.5879L11.199 77.7287L11.3866 77.8695L11.5743 78.0103L11.809 78.198L12.0436 78.3387L12.2782 78.4795L12.5599 78.6673L12.8415 78.808L13.17 79.0427L13.6861 79.3242L14.2962 79.6528L15.0001 80.0751L15.8449 80.5444L16.7835 81.1075L17.769 81.6707L18.8953 82.3277L20.0215 82.9847L21.2417 83.6886L22.5557 84.4395L22.7434 84.5334V79.1835L22.5557 79.0427L21.2417 78.3387L20.0215 77.6348L18.8953 76.9309L17.769 76.3208L16.7835 75.7107L15.8449 75.1945L15.0001 74.7252L14.2962 74.3029L13.6861 73.9274L13.17 73.6459L12.8415 73.4581L12.5599 73.2705L12.2782 73.1297L12.0436 72.9419L11.809 72.8012L11.5743 72.6604L11.3866 72.5196L11.199 72.3319L11.0582 72.1911L10.8704 72.0503L10.7297 71.9095L10.5889 71.7687L10.495 71.628L10.3542 71.4871L10.2604 71.3463L10.1665 71.2056L10.0726 71.0648L10.0258 70.924L9.97878 70.7832L9.88495 70.6424L9.83798 70.5017L9.79112 70.3608V70.2201L9.74414 70.0793V69.9385Z",
    fill: "url(#paint30_linear_2_31607)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6358 66.466C10.6358 66.466 9.74411 67.0291 9.69718 68.7186C9.65025 70.408 9.79113 71.6751 12.8415 73.4114C15.8919 75.1478 43.2514 90.9628 44.2838 91.5729C45.3162 92.183 51.6047 94.0601 57.4238 90.4935C63.243 86.88 88.7253 71.5343 89.9924 70.6426C91.2594 69.751 93.7936 66.3721 89.9924 63.9318C86.1911 61.4915 56.2036 44.4564 54.7958 43.6117C53.3879 42.8139 46.5832 40.749 41.8434 44.8788C37.1505 48.9616 10.6358 66.466 10.6358 66.466Z",
    fill: "#9E96A1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69727 69.5637C9.79112 70.8777 10.3074 71.957 12.8416 73.4118C15.892 75.1951 43.2514 90.9632 44.2839 91.5733C45.2694 92.1364 51.417 94.0136 57.1423 90.6347L29.5013 74.6789L12.7476 67.6865L10.9175 68.9536L9.69727 69.5637Z",
    fill: "#57556A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.968262 15.5485L45.9729 80.2633L47.9439 80.8734C47.9439 80.8734 48.8826 81.108 49.6804 79.4655C50.4781 77.823 51.0413 76.2743 51.4167 73.177C51.7921 70.0797 51.6044 66.7947 50.3373 63.1343C49.0702 59.4738 43.955 48.821 43.0164 47.0377C42.1247 45.2544 36.1648 33.8038 35.7894 33.1468C35.4609 32.4898 35.3201 31.9736 34.4285 31.5043C33.5838 30.9881 3.54934 13.6714 3.3147 13.5306C3.08006 13.3898 2.8923 13.4836 2.79844 13.6244C2.70458 13.7652 0.968262 15.5485 0.968262 15.5485Z",
    fill: "url(#paint31_linear_2_31607)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.089 37.5578C36.8688 35.2583 35.8834 33.3812 35.7895 33.1466C35.461 32.4896 35.3203 31.9734 34.4286 31.5041L29.8296 28.8291V48.9146H38.089V37.5578Z",
    fill: "url(#paint32_linear_2_31607)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875029 17.6128L43.4863 84.8618L44.2841 85.8942L46.2082 86.8328C46.2082 86.8328 47.5221 82.6092 47.9445 80.6851C48.3669 78.761 49.6809 74.7252 49.4932 71.4871C49.3524 68.249 48.8831 65.0579 46.2551 59.4264C43.6271 53.795 34.9452 37.1822 34.476 36.2905C34.0067 35.3989 33.5374 34.4603 33.3966 34.2256C33.2558 33.991 33.115 33.8502 32.6926 33.6156C32.2703 33.381 1.53203 15.6418 1.34432 15.501C1.10967 15.3603 0.921889 15.501 0.921889 15.501L0.0771484 16.5335L0.875029 17.6128Z",
    fill: "url(#paint33_linear_2_31607)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65782 61.8675L44.2837 85.895C44.2837 85.895 46.4893 83.1731 47.2871 80.1228C48.0849 77.0724 49.0704 71.5348 47.8503 67.6397C46.6301 63.7446 42.0311 53.2795 39.7785 49.0559C37.5259 44.8323 32.5046 35.3996 32.3169 35.165C32.1292 34.9303 32.0352 34.9773 31.7537 34.7896C31.4721 34.6019 0.452234 16.6281 0.264519 16.5343C0.0768036 16.4404 -0.0639827 16.5812 0.0298748 16.8158C0.123732 17.0505 1.95391 25.0753 2.56398 27.5625C3.17406 30.0028 4.86352 37.2298 5.52052 39.2008C6.13059 41.1719 6.55291 45.3485 6.64676 47.7888C6.83448 52.3879 5.14504 58.0193 2.65782 61.8675Z",
    fill: "url(#paint34_linear_2_31607)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65771 61.8668L44.2836 85.8943C44.2836 85.8943 46.4892 83.1724 47.287 80.1221C47.5686 79.0427 47.8501 77.7287 48.0848 76.227C46.63 79.1835 45.0814 81.6707 44.9406 81.9523C44.7059 82.3277 44.2836 82.8439 43.7674 82.5623C43.2511 82.2808 13.639 65.1518 12.7474 64.6825C11.9027 64.1663 12.0904 64.2601 11.8558 63.7439C11.6212 63.2277 6.31818 43.5176 6.31818 43.4707C6.5059 45.0194 6.59973 46.6149 6.64666 47.7881C6.83438 52.3871 5.14494 58.0186 2.65771 61.8668Z",
    fill: "url(#paint35_linear_2_31607)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2974 92.5583C69.2974 92.5583 74.5534 89.5079 75.0696 89.2263C75.5858 88.8978 76.806 88.3816 76.806 86.2698C76.806 84.158 76.806 64.7295 76.806 64.7295L71.6438 70.314L69.9544 88.2408L69.2974 92.5583Z",
    fill: "url(#paint36_linear_2_31607)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.012 90.6349C66.012 90.6349 68.6869 91.3857 69.2031 89.6025C69.7193 87.8192 70.4702 72.5673 70.4702 72.5673C71.0333 71.441 71.5965 70.3616 72.1597 69.2354C72.1597 69.9393 72.1597 70.6433 72.1597 71.3941C72.1597 71.3941 71.1272 88.6169 71.0803 89.1801C71.0334 89.7432 70.8926 91.1511 70.0479 91.9958C69.2032 92.8405 68.64 92.8405 67.9361 92.8875C67.2321 92.8875 65.2142 92.3713 64.5103 91.5735L66.012 90.6349Z",
    fill: "url(#paint37_linear_2_31607)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8276 90.212C68.9684 90.0712 69.1093 89.8366 69.1562 89.6019C69.297 89.0388 69.4847 87.2555 69.6724 85.0029L70.7048 90.7282C70.564 91.1506 70.3294 91.5729 70.0009 91.9014C69.7193 92.183 69.4846 92.3238 69.2969 92.4646L68.8276 90.212Z",
    fill: "#4F4835"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.427 74.444L60.474 74.4909L60.5208 74.5378L60.5678 74.5847L60.6146 74.6317L60.6616 74.6786L60.7086 74.7256L60.8024 74.7725L60.8963 74.8194L60.9901 74.8663L61.0839 74.9133L61.1779 74.9602L61.2717 75.0071L61.3656 75.054L61.4594 75.1009L61.5532 75.1479L61.6472 75.2418L61.741 75.3356L61.8348 75.4295L61.9287 75.5233L62.0225 75.5702L62.1165 75.6172L62.2103 75.6641L62.3041 75.711L62.398 75.758L62.4918 75.8049L62.5857 75.8519L62.6796 75.8988L62.7734 75.9457L62.8673 75.9926L62.9611 76.0395L63.0081 76.0865L63.1019 76.1334L63.1957 76.1803L63.2897 76.2273L63.3835 76.2742H63.4773H63.5712H63.665H63.759H63.8528H63.9466H64.0405H64.1343H64.2283H64.3221H64.4159H64.5098H64.6036H64.6975L64.7914 76.2273L64.8852 76.1803L64.979 76.1334L65.0729 76.0865L65.1668 76.0395L65.2607 75.9926L65.3545 75.9457L65.4483 75.8988L65.5422 75.8519L65.6361 75.8049L65.73 75.758L65.8238 75.711L65.9176 75.6172L66.0584 75.5233L66.2931 75.3356L66.6216 75.1009L67.044 74.7725L67.5601 74.397L68.1702 73.9747L68.8272 73.5054L69.5311 72.9892L70.282 72.426L71.0798 71.8629L71.9245 71.2528C73.4732 70.1735 75.0219 69.0941 76.5236 68.0147L77.4621 67.3577C78.6823 66.513 79.8555 65.6683 81.0756 64.7766L81.9204 64.1666L82.7181 63.6034L83.4691 63.0872L84.173 62.6179L84.783 62.1955L85.3462 61.8201L85.8155 61.4916L86.1908 61.21L86.4725 61.0223L86.6601 60.8816L86.7541 60.8346L86.8479 60.7877L86.9417 60.6938L87.0356 60.6L87.1294 60.5061L87.1764 60.4123L87.2234 60.3184L87.2702 60.1776L87.3172 60.0368V59.8961V59.7553L87.1294 57.7373L59.77 71.8629L59.9577 73.8808V73.9747L60.0047 74.0685L60.0515 74.1624L60.0985 74.2563L60.1454 74.3501L60.427 74.444Z",
    fill: "url(#paint38_linear_2_31607)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2396 72.473C60.2396 72.473 62.1636 73.74 62.8676 74.1624C63.5715 74.5378 64.7917 74.5379 65.8241 73.7401C66.8565 72.9423 86.332 59.239 86.7544 58.9105C87.1298 58.582 87.6929 57.6904 86.8951 57.0804C86.0973 56.4703 84.7833 55.7663 84.4548 55.5317C84.1263 55.297 82.7185 55.0624 82.0145 55.5317C81.3106 56.001 60.8027 70.3142 60.2865 70.8305C59.7703 71.3467 59.9111 72.0506 60.2396 72.473Z",
    fill: "#746E70"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.461 91.9013L29.3133 96.4534L17.9565 79.9345L28.187 76.6025L29.4541 77.3534L25.0428 83.0787L31.6129 90.7281L32.5514 90.2119L35.461 91.9013Z",
    fill: "url(#paint39_linear_2_31607)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2598 83.0323L15.1411 78.3394L20.0686 71.9102L28.1873 76.603L23.2598 83.0323Z",
    fill: "#9F9F9F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2598 83.0317L15.1411 78.3389L21.1949 91.7605L29.3136 96.4534L23.2598 83.0317Z",
    fill: "#BABABA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6709 77.26L19.5522 72.6141L20.0685 71.9102L28.1872 76.603L27.6709 77.26Z",
    fill: "#313133"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1516 39.4816C32.2147 38.8502 31.8825 38.2452 31.3158 37.9597L8.23779 26.3326C7.02681 25.7225 5.67807 26.8691 6.08535 28.1625L20.2102 73.0185C20.3285 73.394 20.5866 73.7096 20.9311 73.9L26.2665 76.8485C27.2301 77.3811 28.4243 76.7546 28.5339 75.6591L32.1516 39.4816ZM12.6545 33.7086L24.2295 70.4671L24.4196 70.5722L27.3648 41.12L12.6545 33.7086Z",
    fill: "#7A7676"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9026 39.4816C30.9657 38.8502 30.6334 38.2452 30.0668 37.9597L6.98877 26.3326C5.77778 25.7225 4.42905 26.8691 4.83632 28.1625L18.9612 73.0185C19.0794 73.394 19.3375 73.7096 19.6821 73.9L25.0175 76.8485C25.9811 77.3811 27.1753 76.7546 27.2848 75.6591L30.9026 39.4816ZM11.4054 33.7086L22.9804 70.4671L23.1706 70.5722L26.1158 41.12L11.4054 33.7086Z",
    fill: "#A8A8A8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5562 23.4508L3.74561 12.005C4.707 7.86005 4.87839 5.5367 3.74561 1.3916L24.5562 12.005C25.8311 15.7946 25.8186 18.1505 24.5562 23.4508Z",
    fill: "#707070"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_2_31607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8967 16.9992L9.57246 12.4209L9.15625 13.8776L17.8967 18.6641V16.9992Z",
    fill: "black"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82656 0.142578L3.95361 1.59932L24.7642 12.4208C25.8196 16.9728 25.6308 19.4041 24.7642 23.6585L26.6371 22.8261C27.7281 18.7 27.9929 16.0835 27.2274 12.464C26.9109 10.9669 25.8482 9.75297 24.4688 9.09083L5.82656 0.142578Z",
    fill: "url(#paint40_linear_2_31607)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7495 11.9454L3.76221 1.55199L4.57837 0.974609L24.1336 11.2069C24.7607 11.5329 25.229 12.1131 25.3922 12.8113C26.3271 16.8102 26.2105 18.8228 25.1808 23.0338L24.4032 23.5489C25.4079 19.4403 25.4814 16.8495 24.5817 13.0008C24.476 12.5489 24.1703 12.1642 23.7495 11.9454Z",
    fill: "url(#paint41_linear_2_31607)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.899 30.955L18.7513 35.5071L7.39453 18.9882L17.625 15.6562L17.8974 16.9985L14.4808 22.1324L21.0508 29.7818L21.9894 29.2656L24.899 30.955Z",
    fill: "url(#paint42_linear_2_31607)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6973 22.086L4.57861 17.3931L9.50613 10.9639L17.6248 15.6567L12.6973 22.086Z",
    fill: "#D9D9D9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6973 22.0864L4.57861 17.3936L10.6324 30.8152L18.7511 35.508L12.6973 22.0864Z",
    fill: "#BABABA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_31607",
    x: 5.15625,
    y: 8.4209,
    width: 16.7402,
    height: 14.2432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2_31607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31607",
    x1: 32.6226,
    y1: 95.6312,
    x2: 42.0569,
    y2: 87.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_31607",
    x1: 30.422,
    y1: 93.541,
    x2: 29.2575,
    y2: 92.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_31607",
    x1: 41.8603,
    y1: 105.292,
    x2: 53.4119,
    y2: 105.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#352E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2E261D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#31281F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#272019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B261F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_31607",
    x1: 73.9402,
    y1: 97.9123,
    x2: 84.0038,
    y2: 100.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47483D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#525762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58564A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_31607",
    x1: 74.0436,
    y1: 96.8273,
    x2: 76.7431,
    y2: 98.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F261C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#140C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_31607",
    x1: 76.5772,
    y1: 106.6,
    x2: 80.3805,
    y2: 95.5546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E362A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_31607",
    x1: 56.4294,
    y1: 102.551,
    x2: 70.8237,
    y2: 96.1427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_31607",
    x1: 81.0017,
    y1: 124.133,
    x2: 91.0654,
    y2: 126.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47483D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#252326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#525762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58564A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_31607",
    x1: 81.1041,
    y1: 123.049,
    x2: 83.8037,
    y2: 124.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F261C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#140C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_31607",
    x1: 84.5646,
    y1: 133.008,
    x2: 85.3345,
    y2: 125.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E362A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_31607",
    x1: 62.1566,
    y1: 112.402,
    x2: 53.2764,
    y2: 109.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33291D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_31607",
    x1: 82.0684,
    y1: 119.327,
    x2: 84.7997,
    y2: 119.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33291D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#473E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_31607",
    x1: 51.4583,
    y1: 103.993,
    x2: 58.6333,
    y2: 106.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494A56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_31607",
    x1: 39.7332,
    y1: 136.087,
    x2: 49.1224,
    y2: 138.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#5B5559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4C453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_31607",
    x1: 7.45458,
    y1: 117.215,
    x2: 16.8437,
    y2: 119.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#43302A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#5B5559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4C453B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494134"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_31607",
    x1: 11.9577,
    y1: 119.256,
    x2: 21.3919,
    y2: 111.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F4852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_31607",
    x1: 42.0352,
    y1: 136.038,
    x2: 40.8708,
    y2: 135.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_31607",
    x1: 9.75693,
    y1: 117.167,
    x2: 8.59264,
    y2: 116.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_31607",
    x1: 41.9768,
    y1: 100.186,
    x2: 53.442,
    y2: 100.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#2A2B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2C2A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_31607",
    x1: 43.6753,
    y1: 98.4431,
    x2: 51.6165,
    y2: 98.4431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#443E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#352E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2E261D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#282019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#332B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#31281F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#272019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B261F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_31607",
    x1: 43.0138,
    y1: 120.145,
    x2: 39.8153,
    y2: 120.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5A5140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#675B47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_31607",
    x1: 47.5097,
    y1: 114.745,
    x2: 49.0709,
    y2: 108.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_31607",
    x1: 47.1514,
    y1: 104.058,
    x2: 44.3907,
    y2: 114.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_31607",
    x1: 6.64711,
    y1: 109.998,
    x2: 8.07046,
    y2: 109.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#756D57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F372B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_31607",
    x1: 42.3204,
    y1: 106.706,
    x2: 26.815,
    y2: 110.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F372B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_31607",
    x1: 16.3454,
    y1: 109.835,
    x2: 45.8922,
    y2: 100.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F525B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E424A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_31607",
    x1: 63.0227,
    y1: 37.5833,
    x2: 65.2325,
    y2: 37.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44392D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_31607",
    x1: 89.0896,
    y1: 82.6797,
    x2: 92.3288,
    y2: 82.6797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63595A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686063"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_31607",
    x1: 70.959,
    y1: 88.7483,
    x2: 65.3656,
    y2: 89.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24231F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2_31607",
    x1: 28.0352,
    y1: 89.6732,
    x2: 36.4377,
    y2: 88.1916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2_31607",
    x1: 11.5198,
    y1: 77.2434,
    x2: 22.8602,
    y2: 77.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615856"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2_31607",
    x1: 25.3457,
    y1: 36.9013,
    x2: 26.4579,
    y2: 38.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A598A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72666E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2_31607",
    x1: 28.8501,
    y1: 36.8658,
    x2: 30.4358,
    y2: 38.4514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A598A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72666E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2_31607",
    x1: 22.334,
    y1: 43.5204,
    x2: 24.0303,
    y2: 45.2166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9A9B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9A9A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5A534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2_31607",
    x1: 29.1425,
    y1: 39.3739,
    x2: 13.9793,
    y2: 65.6375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675F4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5E5746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#433B37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D3532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2_31607",
    x1: 20.3414,
    y1: 73.0773,
    x2: 22.8556,
    y2: 68.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4236"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2_31607",
    x1: 76.1869,
    y1: 84.0568,
    x2: 78.4341,
    y2: 87.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2_31607",
    x1: 66.0211,
    y1: 91.9583,
    x2: 70.1661,
    y2: 82.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47412F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2_31607",
    x1: 63.1919,
    y1: 67.0954,
    x2: 65.0633,
    y2: 67.0954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44392D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2_31607",
    x1: 25.8627,
    y1: 81.1636,
    x2: 27.6454,
    y2: 91.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2_31607",
    x1: 5.20225,
    y1: 0.975,
    x2: 26.6371,
    y2: 21.9937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A598A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#958892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62545D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2_31607",
    x1: 4.16233,
    y1: 2.01514,
    x2: 27.6783,
    y2: 22.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#807979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646174,
    stopOpacity: 0.353826
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4034"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2_31607",
    x1: 15.3007,
    y1: 20.2173,
    x2: 17.0834,
    y2: 30.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818181"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairAdjustable);
export default __webpack_public_path__ + "static/media/ChairAdjustable.310db760a562637f848173f6c96de55e.svg";
export { ForwardRef as ReactComponent };